import { formatObjectCreate } from "./formatObject";

export const handlerAddProductCart = (item, context) => {
  context(formatObjectCreate(item))
};